<template>
  <div>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" class="pt-0">
          <div class="primary--text">Finanzas</div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-container fluid>
            <v-row justify="space-between">

              <!-- Ventas netas -->
              <v-col cols="3" class="text-center">
                <v-row v-if="!loading" class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <div class="font-weight-bold color-black">Ventas Netas</div>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h5 class="display-1 primary--text">{{ sales | toFixNumber(2) | numberWithComma | prefix('$') }}</h5>
                  </v-col>
                </v-row>

                <loader :loading="loading"></loader>
              </v-col>

              <span class="vertical-divider"></span>

              <!-- Compras -->
              <v-col cols="3" class="text-center">
                <v-row v-if="!loading" class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <div class="font-weight-bold color-black">Compras</div>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h5 class="display-1 primary--text">{{ purchases | toFixNumber(2) | numberWithComma | prefix('$') }}</h5>
                  </v-col>
                </v-row>

                <loader :loading="loading"></loader>
              </v-col>

              <!-- <span class="vertical-divider"></span> -->

              <!-- Gasto -->
              <!-- <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <div class="font-weight-bold color-black">Gasto</div>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h5 class="display-1 primary--text">$0.00</h5>
                  </v-col>
                </v-row>
              </v-col> -->

              <span class="vertical-divider"></span>

              <!-- Resultado -->
              <!-- <v-col cols="3" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <div class="font-weight-bold color-black">Resultado</div>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h5 class="display-1 primary--text">{{ this.finances ? this.finances.result : 0 | numberWithComma | prefix('$') }}</h5>
                  </v-col>
                </v-row>
              </v-col> -->

              <!-- <span class="vertical-divider"></span> -->

              <!-- Caja -->
              <!-- <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <div class="font-weight-bold color-black">Caja</div>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h5 class="display-1 primary--text">$0.00</h5>
                  </v-col>
                </v-row>
              </v-col> -->
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/Loader'

export default {
  props: {
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  components: { Loader },
  data () {
    return {
      finances: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      restaurant: 'restaurant'
    }),
    purchases () {
      return this.$store.state.currentRestaurant.reports.netTotal
    },
    sales () {
      return this.$store.state.currentRestaurant.reports.totalSales
    }
  },
  async mounted () {
    await this.getFinances()
  },
  methods: {
    async getFinances (dates = []) {
      let [ fromDate ] = dates
      this.loading = true
      try {
        await this.$store.dispatch('currentRestaurant/reports/getNetTotal', {
          date: fromDate,
          type: this.period
        })
        await this.$store.dispatch('currentRestaurant/reports/getTotalSales', {
          date: fromDate,
          type: this.period
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
    }
  },
  watch: {
    dates: function (value) {
      if (value.length >= 2) this.getFinances(value)
    }
  }
}
</script>
